import { ListMetadata } from './../../models/list-metadata.model';
import { AuthService } from './../user/auth.service';
import { Observable } from 'rxjs/Rx';
import { HttpParams, HttpClient } from '@angular/common/http';
import { HttpClientService } from './../httpClient/httpclient.service';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomerSetBuilderService {
  baseUrl = 'koncentro-customers/customers/query';
  queryId: number;

  constructor(
    private http: HttpClientService,
    private authService: AuthService,
    private httpClient: HttpClient
  ) { }

  getqueryId(id: number) {
    this.queryId = id;
  }

  /**
   * Restituisce la query con id uguale queryId.
   * Se richiamato senza queryId restituisce la lista di tutte le query
   */
  getQuery(queryId?: number) {
    let params: HttpParams = new HttpParams();
    if (queryId) {
      params = params.set('id', queryId.toString());
    }
    return this.http.get(`${this.baseUrl}/getQuery`, params.toString());
  }

  saveQuery(queryData: any) {
    return this.http.post(`${this.baseUrl}/saveQuery`, queryData);
  }

  updateQuery(queryData: any) {
    return this.http.put(`${this.baseUrl}/updateQuery`, queryData);
  }

  deleteQuery(queryId: number) {
    return this.http.delete(`${this.baseUrl}/deleteQuery/${queryId}`);
  }

  checkQueryResults(queryData: any) {
    return this.http.post(`${this.baseUrl}/checkResultsQuery`, queryData);
  }

  exportQueryResults(queryData: any) {
    return this.http.post(`${this.baseUrl}/exportQueryResults`, queryData);
  }

  downloadExcel(filename: string): Observable<Blob> {
    const requestBody = {'filename': filename};
    const userCompany = this.authService.user.selectedCompany.toString();
    const token =  `Bearer ${this.authService.user.token}`;
    const language = this.authService.sessionHelper.selectedLanguage;
    const requestHeaders = {
      'Accept-Company': userCompany,
      'Content-Type': 'application/json',
      'Authorization': token,
      'Accept-Language': language
    };
    return this.httpClient.post(
      '/koncentro-customers/download',
      requestBody,
      {
        headers: requestHeaders,
        responseType: 'blob'
      }
    );
  }

  /**
   * Restituisce la lista delle query eseguite.
   * Aggiungendo il parametro "id" restituisce solo le esecuzioni della query relativa.
   */
  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<any>, metadata: ListMetadata }> {
    if (this.queryId) {
      search.push({key: 'id', value: this.queryId.toString()});
    }
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(`${this.baseUrl}/getListQueryExecuted?` + params.toString());
  }

  getListQueryExecuted(id, version, jobId) {
    if(jobId)
      return this.http.getPaged(`${this.baseUrl}/getListQueryExecuted?id=${id}&version=${version}&job_id=${jobId}`);
    else
      return this.http.getPaged(`${this.baseUrl}/getListQueryExecuted?id=${id}&version=${version}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/customer/customer-set-builder.service.ts